<script setup lang="ts">
import { X } from "lucide-vue-next";
import { useUiStore } from "@/stores/ui";
const ui = useUiStore();
</script>

<template>
  <div class="toast-container" aria-live="polite" aria-atomic="false">
    <TransitionGroup name="toast">
      <div
        v-for="t in ui.toasts"
        :key="t.id"
        :class="['toast', `toast-${t.kind}`]"
        role="status"
      >
        <span class="toast-msg">{{ t.message }}</span>
        <button
          v-if="t.action"
          type="button"
          class="toast-action"
          @click="t.action.handler"
        >
          {{ t.action.label }}
        </button>
        <button
          type="button"
          class="toast-close"
          aria-label="Zamknij powiadomienie"
          @click="ui.dismissToast(t.id)"
        >
          <X :size="14" :stroke-width="1.75" />
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.toast-container {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 80;
  display: flex;
  flex-direction: column;
  gap: 8px;
  pointer-events: none;
  max-width: calc(100vw - 48px);
}
.toast {
  background: var(--bg-overlay);
  border: 1px solid var(--line);
  border-left-width: 3px;
  border-radius: var(--r-box);
  padding: 10px 8px 10px 16px;
  box-shadow: var(--shadow-2);
  min-width: 280px;
  max-width: 420px;
  display: flex;
  gap: 8px;
  align-items: center;
  pointer-events: auto;
  font-size: var(--fs-md);
  color: var(--ink-primary);
}
.toast-msg {
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.toast-info { border-left-color: var(--info); }
.toast-success { border-left-color: var(--ok); }
.toast-warn { border-left-color: var(--warn); }
.toast-error { border-left-color: var(--crit); }

.toast-action {
  background: var(--accent-soft);
  border: 1px solid var(--accent);
  border-radius: var(--r-box);
  padding: 4px 10px;
  font-family: var(--font-mono);
  font-size: 10px;
  letter-spacing: .14em;
  text-transform: uppercase;
  color: var(--accent-ink);
  font-weight: 600;
  cursor: pointer;
  flex: none;
}
.toast-action:hover { background: var(--accent); color: var(--fill-navy); }
.toast-action:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 1px;
}

.toast-close {
  background: transparent;
  border: none;
  border-radius: var(--r-box);
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  cursor: pointer;
  color: var(--ink-tertiary);
  flex: none;
}
.toast-close:hover { background: var(--bg-base); color: var(--ink-primary); }
.toast-close:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 1px;
}

.toast-enter-from, .toast-leave-to {
  opacity: 0;
  transform: translateX(40px);
}
.toast-enter-active, .toast-leave-active {
  transition: all 0.2s var(--ease-out);
}
.toast-leave-active { position: absolute; right: 0; }
</style>
